import React from 'react';
import styled, { keyframes } from 'styled-components';

import imgScrollIcon from 'src/assets/images/icons/scroll.svg';

const BannerImage = ({ children }) => {
  return (
    <Root >
      {children}
      <Scroll src={imgScrollIcon} />
    </Root>
  );
};

const Root = styled.div`
  color: #fff;
  height: 100vh;
  background-size: cover;
  background-position: 50% 50%;
`;

const animateScroll = keyframes`
  0% {
    transform: translateY(0) translateX(-50%);
    opacity: 0;
  }
  20%,
  50% {
    opacity: 1;
  }
  70%, 100% {
    transform: translateY(7px) translateX(-50%);
    opacity: 0;
  }
`;

const Scroll = styled.img`
  position: absolute;
  bottom: 7.5vh;
  left: 50%;
  transform: translateX(-50%);
  animation: ${animateScroll} 2s infinite cubic-bezier(0.65, 0.05, 0.36, 1);
`;

export default BannerImage;



// WEBPACK FOOTER //
// ./src/components/BannerImage.js